export default __webpack_public_path__ + "static/media/volkihar-slide-1.5d2fbc06.jpg";